module.exports = __webpack_public_path__ + "img/hotdog-top-sra004.9135b29c.jpg";